import { createSelector } from 'reselect';
import ReceptaclesInPreconNotInPredesDetailsColumns
  from '../../containers/ReceptaclesInPreconNotInPredesDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .RECEPTACLES_IN_PRECON_NOT_IN_PREDES_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ReceptaclesInPreconNotInPredesDetailsColumns);
